import angular from 'angular';
import csmTools from '../../util/tools/tools';
import './inlineInput.css';

export default angular
  .module('csm.ui.inlineInput', [csmTools])

  /*****************************************************************************
   * Directive: inlineInput */
  /**
   * This directive is used to have a label and a control be displayed inline
   * together. This can work with the inlineLabelGroup to set the label width
   * to the largest in the group.
   *
   * Note: The transcluded element needs to have padding added for any child
   *       image inputs (checkbox) as they don't have content so the box layout
   *       will not be calculated without at least 1px for a given dimension.
   *****************************************************************************/
  .directive('inlineInput', function (Tools) {
    return {
      restrict: 'E',
      require: '?^inlineLabelGroup',
      scope: { label: '@', required: '@' },
      transclude: true,
      template:
        '<div class="inline-line"><span class="inlineLabel" ng-class="{\'req\': isRequired()}" ng-bind="label"></span><div class="inlineWrap"><ng-transclude></ng-transclude></div></div>',
      link: function (scope, element, attr, groupController) {
        /** Label width changed. */ var mLabelChanged = false;
        /** Span label accessor. */ var getSpan = function () {
          return angular.element(element[0].querySelector('span'));
        };

        /** Returns boolean indication that required property is set. */
        scope.isRequired = function () {
          return scope.required == 'true';
        };

        /*************************************************************************
         * setLabelWidth */
        /**
         * This updates the labelStyle scope object for the width. The widthString
         * is parsed to get the numeric value. The width is set when a positive
         * value is available.
         *
         * @param widthString  widthString to update the labelStyle object
         *************************************************************************/
        var setLabelWidth = function (widthString) {
          /*---------------------------------------------*/
          /* No change is made when there is a label     */
          /* set and this call isn't from a label change */
          /*---------------------------------------------*/
          if (!Tools.isEmpty(element.attr('label-width')) && !mLabelChanged)
            return;

          var width = Number((widthString || '').toString().replace(/\D/g, ''));
          getSpan().css('width', width > 0 ? width.toString() + 'px' : '');
        };

        /*-------------------------------------------------*/
        /* Watch for changes for the label-width attribute */
        /*-------------------------------------------------*/
        scope.$watch(
          function () {
            return element.attr('label-width');
          },
          function (widthText) {
            mLabelChanged = true;
            setLabelWidth(widthText);
            mLabelChanged = false;
          }
        );

        /*-------------------------------------------------*/
        /* Adjust ng-transclude element to include padding */
        /* when the direct child is a checkbox input       */
        /*-------------------------------------------------*/
        if (
          element[0].querySelector(
            'div > div > ng-transclude > input[type=checkbox]'
          )
        )
          angular
            .element(element[0].querySelector('div > div > ng-transclude'))
            .css('padding', '0.5px');

        /*-----------------------------------------------*/
        /* Link up to direct parent label group if there */
        /*-----------------------------------------------*/
        if (
          groupController != undefined &&
          element.parent().attr('inline-label-group') != undefined
        ) {
          /*----------------------------------*/
          /* Line object with width accessors */
          /*----------------------------------*/
          var obj = {
            getWidth: function () {
              return getSpan()[0].clientWidth;
            },
            setWidth: setLabelWidth
          };
          groupController.add(obj);
          scope.$on('$destroy', function () {
            groupController.remove(obj);
          });

          /*--------------------------------------------------*/
          /* Set up watcher for label text changes to trigger */
          /* a group refresh. Ignore the first listener as    */
          /* the refresh is called when added to the group    */
          /*--------------------------------------------------*/
          var firstWatch = true;
          scope.$watch('label', function () {
            if (firstWatch) firstWatch = false;
            else groupController.refreshWidth();
          });

          /*-----------------------------------------------------------------*/
          /* If the label has not been drawn yet, indicated by a zero width, */
          /* add a watch to refresh the widths when it has been rendered.    */
          /*-----------------------------------------------------------------*/
          if (obj.getWidth() == 0) {
            var drawWatch = scope.$watch(
              function () {
                return obj.getWidth;
              },
              function (width) {
                if (!width) return;
                drawWatch();
                groupController.refreshWidth();
              }
            );
          }
        }
      }
    };
  }).name;
